import React from 'react';
import '../iinc/iGlobal';
import '../../inc/genstyle.css';
import logoPS from '../../assets/logo-ps.png';
import IDashboard from './ihomepage';
import WarningIcon from '@mui/icons-material/Warning';
import { GoogleLogin } from '@react-oauth/google';


const authKey = global.config.authBearerKey;

class ILogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSignedIn: false,
            statLoad: 0
        }
        this.clearSession = this.clearSession.bind(this);
    }
    clearSession() {
        localStorage.clear();
        console.log('User signed out.');
        window.location.reload();
    }

    cekLogin(dataText) {
        var data = JSON.parse(dataText); 
        fetch(global.config.urlLink+"/ceklogin", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': authKey,
            }, body : JSON.stringify(data)
          }).then(res2 => {
            if(res2.status === 200) 
                return res2.json() 
          }).then( resJson => {
            if(resJson.status === '200') {
                var uroles = [];
                if(resJson.values[0].userRole !== '') {
                    var arrUserRole = resJson.values[0].userRole.split("$$");
                    for(var ur=0; ur<global.config.userrole.length; ur++) {
                        var resuroles = "";
                        for(var ir=0; ir<arrUserRole.length; ir++) {
                            if(global.config.userrole[ur] === arrUserRole[ir]) {
                                resuroles = "ON"; break;
                            } else { resuroles = "OFF"; }
                        }
                        uroles.push(resuroles);
                    }
                } 
                
                var uidValue = data.user_email; 
                var utkValue = data.user_id; 

                localStorage.setItem('uid', uidValue);
                localStorage.setItem('utk', utkValue);
                localStorage.setItem('udocid', resJson.values[0].docid);
                localStorage.setItem('uposition', resJson.values[0].userPosition);
                localStorage.setItem('ulevel', resJson.values[0].userLevel);
                localStorage.setItem('ufullname', resJson.values[0].userFullname);
                localStorage.setItem('urole', JSON.stringify(uroles));
                localStorage.setItem('upicture', data.user_picture);
                this.setState( prevState => {
                    return {  
                        ...prevState.isSignedIn, isSignedIn: true,
                        ...prevState.statLoad, statLoad: 1
                    }
                })
            } else {
                document.getElementById("errormsg").style.display = "block"; 
                this.setState( prevState => {
                    return {  
                        ...prevState.isSignedIn, isSignedIn: false,
                        ...prevState.statLoad, statLoad: 1
                    }
                })
                localStorage.clear();
            }
          }).catch(err => err);

    }
    successLogin = (response) => {
        document.getElementById("errormsg").style.display = 'none';
        var dataSend = response;
        fetch(global.config.urlLink+"/getggprofile", {
            method: 'POST',
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': "*",
                'Authorization': authKey
            },
            body: JSON.stringify(dataSend),
          })
          .then(response => {
            if(response.status === 200) {  return response.json(); } 
          })
          .then(resJson => {
            var dataTextSend = '{"user_email":"' + resJson.values.email + '","user_id":"' + resJson.values.sub + '","user_fullname":"' + resJson.values.name + '","user_picture":"' + resJson.values.picture + '"}';
            this.cekLogin(dataTextSend);
          });
    
    }    
    onLoginFailed(err) {
        document.getElementById("errormsg").style.display = "block";
        this.setState( prevState => {
            return {  
                ...prevState.isSignedIn, isSignedIn: false,
                ...prevState.statLoad, statLoad: 1
            }
        })
    }
    
    componentDidMount() {
        document.getElementById("errormsg").style.display = 'none';
    }

    getContent() {
        if (this.state.isSignedIn === true) {
            return <div><IDashboard/></div>
        } else {
              return (
                <div className="main-container center-screen">
                    <div className="login-area divMiddle">
                        <div className="mgT30 divCenter"><img src={logoPS} alt="pointstar" width="150"></img></div>
                        <div className="mgT20 mgB30 divCenter textBold">Sign in with your PointStar Intranet Account</div>
                        <div className="mgT20 mgB20 divCenter"><div className="divhide w70p" id="errormsg"><WarningIcon severity="error" />You are not successfully login.<br/>Please contact administrator for more information</div></div>
                        <div className="mgT30 mgB50 divCenter">
                            <GoogleLogin 
                                type="standard"
                                theme="outline"
                                text="signin"
                                shape="rectangular"
                                onSuccess={this.successLogin}
                                onError={this.onLoginFailed}
                                
                            /> 
                            <div id="logoutButton" className="divHide">
                                <button className="genButton mgL20" onClick={() => this.clearSession()}>clear</button>
                            </div>
                        </div>
                    </div>
                </div>
              )
        }
    
    }
    

    render() {
        return (
            <div>{this.getContent()}</div>
           
        )
    }
}
export default ILogin;
